import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link as RouterLink, useMatch } from 'react-router-dom';
import { Link, StudyString, useLocalizeMessage } from 'libs.nucleus';
import ScheduleCardWrapper from './components/schedule_card_wrapper.component';
import { getRouteLink } from '../../helpers/links.helpers';
import { getOnboardingConfig } from '../../helpers/study.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
import { useOrgContext } from '../../hooks/use_org_context';
export const OnboardingSchedule = ({ onboardingScheduleActivities, setCurrentVisit, setIsActivityListModalOpen, }) => {
    const translate = useLocalizeMessage();
    const org = useOrgContext();
    const onboardingConfig = getOnboardingConfig(org);
    const onboardingGroupId = onboardingConfig?.c_group_id;
    const onboardingDisplayName = onboardingConfig?.c_display_name ?? '';
    const match = useMatch('/site/study/:studyId/participants/:participantId/*');
    const participantId = match?.params.participantId;
    const { environment } = useCurrentEnvironment();
    const onOnboardingScheduleClick = () => {
        setCurrentVisit({
            c_visit: '',
            c_name: onboardingDisplayName ?? '',
            c_group: onboardingGroupId ?? '',
            c_window_start: Date.now(),
            c_window_end: Date.now(),
            c_open_queries: 0,
            c_completed_assignments: 0,
            c_completed_assignments_for_site: 0,
            c_sequence: 0,
            assignments: onboardingScheduleActivities.length,
            total_activities_count: onboardingScheduleActivities.length,
            customVisitType: 'onboarding',
        });
        setIsActivityListModalOpen();
    };
    return (_jsx(_Fragment, { children: _jsx(ScheduleCardWrapper, { "data-testid": `visit-schedule-onboarding`, onClick: onOnboardingScheduleClick, onActionBtnClick: onOnboardingScheduleClick, actionBtnProps: {
                'label': translate('action.onboarding.view'),
                'aria-label': 'view-onboarding-schedule',
                'dataTestId': 'view-onboarding-schedule',
            }, children: _jsxs("div", { className: 'col-span-2', children: [_jsx("div", { "data-testid": `visit-title-onboarding`, className: 'text-primary-500 flex gap-2', children: _jsx(Link, { LinkComponent: RouterLink, to: getRouteLink(`participants/${participantId}/non-visit/${onboardingGroupId}`, environment), "data-testid": 'onboarding-name', children: _jsx(StudyString, { children: onboardingDisplayName }) }) }), _jsx("div", { "data-testid": 'onboarding-assessments', className: 'text-gray-500', children: translate('label.visit_schedule.site_activities', {
                            assignments: onboardingScheduleActivities.length,
                            count: onboardingScheduleActivities.length,
                        }) })] }) }) }));
};
